import { layoutHeaderDisabled } from '@/lib/layout/layoutHeaderDisabled';
import {
    ANALYZE_INDUSTRY_BENCHMARK,
    CAPTIONS_LISTS,
    CONTENT_ALBUMS,
    CONTENT_ALBUMS_COMPARATIVE_TABLE,
    INSPIRATION,
    LISTENING_COMPETITORS,
    LISTENING_FEEDS,
    LISTENING_HASHTAGS,
    MANAGE_COMMENTS_TRACKER,
    MANAGE_DM_TRACKER,
    MANAGE_IMPORTANT_TRACKER,
    MANAGE_MENTIONS_TRACKER,
    MANAGE_RESOLVED_TRACKER,
    MEDIA_LIBRARY,
    SCHEDULER,
    SCHEDULER_FEED_VIEW
} from '@/lib/routes/privateRoutes';

export const layoutHeaderDatepickerGlobalDisabled = [
    ...layoutHeaderDisabled,
    LISTENING_COMPETITORS,
    LISTENING_HASHTAGS,
    CONTENT_ALBUMS,
    CONTENT_ALBUMS_COMPARATIVE_TABLE,
    INSPIRATION,
    LISTENING_FEEDS,
    ANALYZE_INDUSTRY_BENCHMARK,
    SCHEDULER,
    SCHEDULER_FEED_VIEW,
    MEDIA_LIBRARY,
    CAPTIONS_LISTS,

    // Conversations
    MANAGE_COMMENTS_TRACKER,
    MANAGE_MENTIONS_TRACKER,
    MANAGE_DM_TRACKER,
    MANAGE_IMPORTANT_TRACKER,
    MANAGE_RESOLVED_TRACKER
];
